import { useFetchQuery } from "common/queries/hooks";

import {
  ControlledSubstanceGuidance,
  ControlledSubstancePolicy,
  ControlledSubstancePolicySearch,
} from "../types";
import { keys, urls } from "./constants";

export const useControlledSubstanceGuidanceQuery = ({ enabled }: { enabled: boolean }) => {
  return useFetchQuery<ControlledSubstanceGuidance>(keys.guidance(), {
    fetch: { url: urls.controlledSubstanceGuidance() },
    config: { enabled },
  });
};

export const useControlledSubstancePolicyQuery = (
  search: ControlledSubstancePolicySearch,
  { enabled }: { enabled: boolean },
) => {
  return useFetchQuery<ControlledSubstancePolicy, ControlledSubstancePolicySearch>(
    keys.policyList(search),
    {
      fetch: { url: urls.controlledSubstancePolicy(), body: search },
      config: { enabled: enabled && !!search.item_ids.length },
    },
  );
};
